<template>
  <div class="project-header" v-if="!parent.showFixedHeader">
    <div class="project-nav-container">
      <ProjectNav :projects="parent.projects" :parent="parent"/>
      <div
        class="scroll-hint"
        :class="{'animated infinite pulse show':parent.currentProjectView}"
      >&darr; SCROLL DOWN FOR MORE CONTENTS &darr;</div>
    </div>
    <div id="project-header-container" :style="{'--color':parent.selectedProject.bgColor}">
      <div
        class="project-image-container"
        v-for="( project, index) in parent.projects"
        :key="index"
        :class="{'active':parent.selectedProject.id===project.id}
            "
      >
        <div
          class="project"
          v-lazy:background-image="parent.getImageUrl(project.cover)"
          :key="parent.getImageUrl(project.cover)"
        ></div>

        <div class="project-view-title animated">
          <span class="project-name animated">{{project.name}}</span>
          <span class="project-category animated">{{project.category}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectNav from "../components/project-nav.vue";

export default {
  name: "project-header",
  components: {
    ProjectNav
  },
  props: ["parent"],
  mounted() {
    this.$eventBus.$on("updateProjectView", this.animateInProjectView);
    this.$eventBus.$on("removeProjectView", this.animateOutProjectView);

    if (this.parent.currentProjectView !== null) {
      this.animateInProjectView();
    } else {
      this.openingPageAnimation();
    }
  },
  data() {
    return {
      pageWidth: 0,
      pageHeight: 0,
      timer: null
    };
  },
  methods: {
    delayTime(t) {
      return new Promise(resolve => {
        if (this.timer !== null) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          resolve();
        }, t);
      });
    },
    async openingPageAnimation() {
      const eles = this.getAnimateElements();
      const allNavs = document.querySelectorAll(".project-header .nav-item");
      eles.coverMask.classList.remove("active");
      eles.coverMask = document.querySelector(
        ".project-header .project-image-container"
      );
      this.parent.selectedProject = this.parent.projects[0];

      eles.projectContainer.classList.add("open-backdrop");

      allNavs.forEach(nav => nav.classList.remove("fadeInLeft"));
      eles.navs.style.display = "block";
      await this.delayTime(100).then(() =>
        eles.coverMask.classList.add("active")
      );

      const loop = async array => {
        let index = 0;

        while (index < array.length) {
          await this.delayTime(100).then(() => {
            array[index].classList.add("fadeInLeft");
          });
          index++;
        }
      };
      await this.delayTime(1000).then(() => loop(allNavs));
      this.parent.enableHover = true;
    },

    async animateInProjectView() {
      this.parent.enableHover = false;
      this.parent.disableScroll();
      const eles = this.getAnimateElements();

      eles.projectName.classList.remove("fadeOutDown");
      eles.projectCategory.classList.remove("fadeOutDown");
      eles.coverMask.classList.add("view");

      await this.delayTime(1200).then(() => {
        eles.projectName.classList.add("fadeInUp");
      });

      await this.delayTime(300).then(() =>
        eles.projectCategory.classList.add("fadeInUp")
      );
      this.delayTime(1500).then(() => {
        eles.projectGallery.classList.add("active");
        this.parent.enableScroll();
      });
    },
    async animateOutProjectView() {
      const eles = this.getAnimateElements();

      eles.navs.style.display = "none";
      eles.coverMask.classList.remove("no-transition");
      eles.activeCover.classList.remove("no-transition");
      eles.projectName.classList.remove("no-transition");
      eles.projectCategory.classList.remove("no-transition");

      eles.projectGallery.classList.remove("active");
      eles.projectCategory.classList.add("fadeOutDown");

      await this.delayTime(300).then(() => {
        eles.projectName.classList.add("fadeOutDown");
      });
      eles.coverMask.classList.add("close");
      eles.projectContainer.classList.remove("open-backdrop");
      await this.delayTime(1000).then(() =>
        eles.projectContainer.classList.add("close-backdrop")
      );
      await this.delayTime(1000).then(() =>
        eles.projectContainer.classList.remove("close-backdrop")
      );
      eles.coverMask.classList.remove("view", "close");
      this.openingPageAnimation();

      //clear classes
      eles.projectName.classList.remove("fadeInUp");
      eles.projectCategory.classList.remove("fadeInUp");
    },
    getAnimateElements() {
      const isActive = document.querySelector(
        ".project-header .project-image-container.active"
      );
      const coverMask =
        isActive === null
          ? document.querySelector(".project-header .project-image-container")
          : isActive;

      return {
        projectGallery: document.getElementById("project-gallery"),
        projectContainer: document.getElementById("project-header-container"),
        navs: document.querySelector(".project-header .project-nav"),
        activeCover: coverMask.querySelector(".project"),
        coverMask: coverMask,
        projectName: coverMask.querySelector(".project-name"),
        projectCategory: coverMask.querySelector(".project-category")
      };
    }
  },
  beforeDestroy() {
    //header.parentNode.removeChild(header);
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }
    this.$eventBus.$off("updateProjectView", this.animateInProjectView);
    this.$eventBus.$off("removeProjectView", this.animateOutProjectView);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.project-header {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
}

#project-header-container:after {
  content: "";
  background-color: var(--color);
  width: 100%;
  height: 100%;
  display: block;
  /* transition: background-color 0.6s ease-in-out; */
  transition: all 0.6s cubic-bezier(0.8, 0.03, 0.25, 1);
  z-index: -1;
  position: absolute;
  top: 0;
  right: 0;
}
.project-nav-container {
  width: 100%;
}

#project-header-container {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 0;
}
.project {
  position: absolute;
  width: 80vw;
  height: 100%;
  top: 0;
  right: 0;
  background-position: right;
  background-repeat: no-repeat;
  background-size: cover;
  transition: 0.6s all ease-in-out;
  transition-delay: 0.6s;
  background-color: white;
}
.scroll-hint {
  position: absolute;
  bottom: 1rem;
  left: 6%;
  font-size: 0.75rem;
  color: #949494;
  animation-duration: 2s;
  opacity: 0;
  transition: 0.5s opacity ease-in-out 2s;
}
.show {
  opacity: 1;
}

.project-image-container {
  right: 0;
  position: absolute;
  overflow: hidden;
  width: 0;
  height: calc(100% - 80px);
  transition: width 0.6s cubic-bezier(0.8, 0.03, 0.25, 1),
    -webkit-width 0.6s cubic-bezier(0.8, 0.03, 0.25, 1);
}
.project-image-container.view .project {
  width: 100vw;
}

.project-view-title {
  position: absolute;
  color: white;
  top: 50%;
  left: 10%;
  display: flex;
  flex-direction: column;
  animation-duration: 0.5s;
  /* animation-delay:1s; */
  opacity: 1;
  width: 100%;
  transition: all 1s ease-in-out;
}
.project-view-title:before {
  opacity: 0;
}
.project-image-container.view .project-view-title:before {
  opacity: 1;
  content: "";
  position: absolute;
  width: 30px;
  height: 3px;
  top: -2rem;
  background-color: #fff;
}
.project-view-title .project-name {
  font-size: 3rem;
  /* line-height: 1.5rem; */
  font-weight: bold;
  opacity: 0;
  animation-duration: 0.3s;
  /* animation-delay: 1.5s; */
}
.project-view-title .project-category {
  font-size: 1.5rem;
  animation-duration: 0.3s;
  /* animation-delay: 1.8s; */
  text-transform: uppercase;
  opacity: 0;
}

.active {
  opacity: 1;
  transition-delay: 0.6s;
  width: 200%;
  background-size: cover;
  width: calc(100% + 80px);
  z-index: 99;
}

.view {
  width: 200% !important;
  z-index: 99;
}

.close {
  width: 0% !important;
}
#project-header-container.open-backdrop:after {
  transform: translateY(0%);
  animation: tranformY-animation 1s cubic-bezier(0.6, 0.03, 0.25, 1); /* transform: translateY(0%); */
}
#project-header-container.close-backdrop:after {
  transform: translateY(100%);
  animation: tranformYOut-animation 1s cubic-bezier(0.6, 0.03, 0.25, 1); /* transform: translateY(0%); */
}

@keyframes tranformYOut-animation {
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(-100%);
  }
}

@keyframes tranformY-animation {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0%);
  }
}

.no-transition {
  transition: none !important;
  animation-delay: 0;
  transition-delay: 0;
}
</style>
